<template>
  <div class="product-listing w-100 relative " :class="isFoodPartner ? '': 'm0'">
    <button class="slick-button slick-button-prev responsibility"
            :class="{ 'slick-button-green': currentPage < products.length - slidesPerPage, 'hidden-button' : products.length <= 4, 'hidden' : products.length <= 2 }"
            @click="showNext"
    >
      <i class="material-icons p15 pointer">keyboard_arrow_right</i>
    </button>
    <VueSlickCarousel class="w-100"
                      v-bind="config"
                      ref="slick"
                      @afterChange="setMuted"
    >
      <div v-for="product in products"
           :key="product.entity_id"
           class="col-xs-12 col-sm-12 col-md-12 flex"
      >
        <product-tile-slider class="collection-product"
                             :product="product"
                             :labels-active="false"
                             :only-image="false"
        />
      </div>
    </VueSlickCarousel>
    <button class="slick-button slick-button-next responsibility"
            :class="{ 'slick-button-green': currentPage > 0, 'hidden-button' : products.length <= 4, 'hidden' : products.length <= 2 }"
            @click="showPrevious"
    >
      <i class="material-icons p15 pointer">keyboard_arrow_left</i>
    </button>
  </div>
</template>

<script async>
import { mapGetters } from 'vuex'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

const ProductTileSlider = () => import(/* webpackChunkName: "vsf-product-tile-slider" */ 'theme/components/core/ProductTileSlider');

let lastHero = 0

export default {
  name: 'ProductListing',
  components: {
    VueSlickCarousel,
    ProductTileSlider
  },
  data () {
    return {
      currentPage: 0
    }
  },
  props: {
    products: {
      type: null,
      required: true
    },
    columns: {
      type: [Number, String],
      required: true
    },
    config: {
      type: Object,
      default: () => ({
        slidesToShow: 6,
        slidesToScroll: 6,
        perPage: 3,
        paginationEnabled: false,
        arrows: false,
        infinite: false,
        draggable: false,
        cssEase: 'ease-out',
        speed: 500,
        'responsive': [
          {
            'breakpoint': 1200,
            'settings': {
              'slidesToShow': 4,
              'slidesToScroll': 4,
              'arrows': false
            }
          },
          {
            'breakpoint': 500,
            'settings': {
              'slidesToShow': 2,
              'slidesToScroll': 2,
              'arrows': false
            }
          }
        ]
      })
    }
  },
  computed: {
    ...mapGetters({
      currentPartnerCode: 'partners/getCurrentPartnerCode',
      currentPartner: 'partners/getCurrentPartner'
    }),
    slidesPerPage () {
      const active = (this.config.responsive || [])
        .filter(item => window.innerWidth < item.breakpoint)
        .sort((a, b) => a.breakpoint - b.breakpoint)[0]
      return active ? active.settings.slidesToShow : this.config.slidesToShow
    },
    isFoodPartner () {
      if (this.currentPartner) {
        return this.currentPartner.display_mode === 'food'
      }
      return false
    }
  },
  methods: {
    wide (isOnSale, isNew, index) {
      let deltaCondition = index > 0 && ((index - 1) - lastHero) % 2 === 0
      // last image always shouldn't be big, we also need to count from last promoted to check if it will look ok
      let isHero = ((isOnSale === '1' || isNew === '1') && deltaCondition) || (index === this.products.length - 1 && (index - lastHero) % 2 !== 0)
      if (isHero) {
        lastHero = index
      }
      return isHero ? 'col-xs-12' : 'col-xs-6'
    },
    showNext () {
      this.$refs.slick.next();
    },
    showPrevious () {
      this.$refs.slick.prev();
    },
    setMuted (currentPage) {
      if (currentPage > this.maxPage) {
        this.maxPage = currentPage;
        if (this.total > currentPage) {
          this.loadMoreProducts()
        }
      }
      this.currentPage = currentPage
    }
  }
}
</script>
<style lang="scss" scoped>
  .hidden-button{
    visibility: hidden;
    @media (max-width: 500px) {
      visibility: visible;
    }
  }
  .product-listing{
    overflow: hidden;
    min-height: 365px;

    @media only screen and (max-width: 991px) {
      min-height: 310px;
    }

    @media only screen and (max-width: 768px) {
      min-height: 240px;
    }

    @media only screen and (max-width: 500px) {
      min-height: auto;
    }
  }
  .slick-button {
    z-index: 1;
    border: 0px;
    border-radius: 50%;
    transition: opacity 200ms linear 0s;
    text-align: left;
    line-height: 1;
    color: rgb(255, 255, 255);
    width: 55px;
    height: 55px;
    padding: 0;

    i{
      font-size: 28px;
      padding: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .slick-button-green {
    background-color: rgba(0, 0, 0, 0.9);
    box-shadow: rgba(0, 0, 0, 0.26) 0px 1px 2px 0px, rgba(0, 0, 0, 0.16) 0px 1px 4px 0px;
  }

  .slick-button-prev {
    position: absolute;
    right: -25px;
    top: 30%;
    transform: translateY(-50%);
    i{
      left: 5px;
    }
  }

  .slick-button-next {
    position: absolute;
    left: -25px;
    top: 30%;
    transform: translateY(-50%);
    i{
      right: 5px;
    }
  }

</style>
